<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <p style="margin-top: -25px; font-size:12px;"><i>Paid Once</i></p>

    <div class="row" v-if="userData.permissions['view_membershipfees']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date"></div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary"  @click="FilterData"><i class="mdi mdi-filter"></i> Filter</b-button></div>
              </div>
              <span v-show="userData.permissions['new_membershipfees']==1" class="mt-4"><b-button v-b-modal.new-registration variant="primary" type="button" class="btn-sm btn"><i class="mdi mdi-plus"></i> New Registration Fees</b-button></span>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(memberid)="data">
                <b class="text-info">{{ data.item.member.member_id }}</b>
              </template>
              <template #cell(member)="data">
                  <router-link :to="{
                    path: '/memberprofile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                    </span>
                  </router-link>
                </template>
              <template #cell(amount)="data">
                {{ commas(data.item.amount) }}
              </template>
              <template #cell(mode_of_payment)="data">
                {{ data.item.mode_of_payment.name }}<br>
                <b class="text-info">{{ data.item.mode_of_payment.account_number }}</b>
              </template>
              <template #cell(approval)="data">
                  <span  class="text-info" v-if="data.item.status==2">
                    <b-button class="btn-sm" variant="light">Approved</b-button>
                  </span>
                  <span v-else>
                    <b-button v-show="userData.permissions['approve_membershipfees']==1" @click="approve(data.item.id,data.item.member,data.item.amount,data.item.mode_of_payment,data.item.reference,data.item.date_of_payment )" type="button" class="btn-sm" variant="primary" v-b-modal.edit>Approve</b-button>
                  </span>
                </template>
                <template #cell(reference)="data">
                <small>{{ data.item.reference }}</small>
              </template>
                <template #cell(addedby)="data">
                {{ data.item.addedby.username }}
                <small class="text-primary fw-bold d-block">{{ data.item.date_of_payment }}</small>
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                  <router-link v-show="data.item.status==2" :to="{ path: '/printregistrationfee',  query: { id: data.item.id }}"  type="button" class="btn-sm btn-dark" title="Print"> <i class="mdi mdi-printer"></i></router-link>
                  <b-button v-show="userData.permissions['edit_membershipfees']==1" :disabled="data.item.status==2" @click="edit(data.item.id,data.item.member.member_id,data.item.amount,data.item.mode_of_payment.id,data.item.reference,data.item.date_of_payment )" type="button" class="btn-sm btn" variant="info" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button v-show="userData.permissions['delete_membershipfees']==1" :disabled="data.item.status==2" @click="remove(data.item.id,data.item.member.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                  <b>Total Fees : {{ commas(totalfees) }}</b>
                </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Registration Fees</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-registration" centered title="New Registration Fees" title-class="font-18" hide-footer>
        <form @submit.prevent="addRegistrationFees">
            <div class="form-group mb-2">
              <label>Member</label> <small class="text-danger">*</small>
                <v-select :options="members" placeholder="Select an Option" v-model="member" label="name" :reduce="member => member.member_id"></v-select>
            </div>
            <div class="form-group mb-2">
            <label>Member ID</label>
            <input v-model="member" type="text" readonly class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Registration Fee</label>
            <input v-model="amount" :min="amount" type="number" class="form-control" />
            </div>
            <div class="form-group mb-2">
              <label>Mode of Payment</label> <small class="text-danger">*</small>
                <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name" :reduce="mode_of_payment => mode_of_payment.id"></v-select>
            </div>
            <div class="form-group mb-2">
            <label>Reference</label>
            <textarea v-model="reference" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Date of Payment</label>
            <input v-model="date_of_payment" :max="currentdate" type="date" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-registration')" >Close</b-button>
                <b-button type="submit" :disabled="saveBtn" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

     <b-modal id="edit-registration" centered title="Edit Registration Fees" title-class="font-14" hide-footer>
        <form @submit.prevent="editRegistrationFees">
          <div class="form-group mb-2">
              <label>Member</label> <small class="text-danger">*</small>
                <v-select :options="members" placeholder="Select an Option" v-model="member" label="name" :reduce="member => member.member_id"></v-select>
            </div>
            <div class="form-group mb-2">
            <label>Member ID</label>
            <input v-model="member" type="text" readonly class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Registration Fee</label>
            <input v-model="amount" type="number" class="form-control" />
            </div>
            <div class="form-group mb-2">
              <label>Mode of Payment</label> <small class="text-danger">*</small>
                <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name" :reduce="mode_of_payment => mode_of_payment.id"></v-select>
            </div>
            <div class="form-group mb-2">
            <label>Reference</label>
            <textarea v-model="reference" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Date of Payment</label>
            <input v-model="date_of_payment" :max="currentdate" type="date" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-registration')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="approve-registration" centered title="Are you sure you want to Approve Registration Fees" title-class="font-14" hide-footer>
        <form @submit.prevent="approveRegistrationFees">
          <div class="form-group mb-2">
              <label>Member : </label> 
              <h5 ><span class="text-info h5" v-html="member"></span> - <span class="text-info h5" v-html="membername"></span></h5>
            </div>
            <div class="form-group mb-2">
            <label>Registration Fee</label>
              <h5 class="text-info" v-html="commas(amount)"></h5>
            </div>
            <div class="form-group mb-2">
              <label>Mode of Payment</label> 
              <h5 class="text-info" v-html="mode_of_payment"></h5>
            </div>
            <div class="form-group mb-2">
            <label>Reference</label>
              <h5 class="text-info" v-html="reference"></h5>
            </div>
            <div class="form-group mb-2">
            <label>Date of Payment</label>
              <h5 class="text-info" v-html="date_of_payment"></h5>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn" variant="secondary" @click="$bvModal.hide('approve-registration')" >Close</b-button>
                <b-button type="submit" class="btn ms-1" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

     <b-modal id="delete-registration" centered title="Delete Registration Fees" title-class="font-18" hide-footer>
        <form @submit.prevent="removeRegistrationFees">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Registration Fees for : <b>{{ membername }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-registration')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { registrationfeeMethods, registrationfeeComputed, memberMethods, memberComputed, paymentoptionMethods, paymentoptionComputed} from "@/state/helpers";

export default {
  page: {
    title: "Registration Fees",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Registration Fees",
      items: [ {text: "Dashboard",to: "/",}, {text: "Registration Fees",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'member', label: 'Name', visible: true },
          { key: 'amount', label: 'Amount', visible: true },
          { key: 'mode_of_payment', label: 'Mode of Payment', visible: true },
          { key: 'reference', label: 'Reference', visible: true },
          { key: 'addedby', label: 'Added by', visible: true },
          { key: 'approval', label: 'Approval', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      member:'',
      amount:'',
      mode_of_payment:'',
      reference:'',
      date_of_payment:new Date().toLocaleDateString('fr-CA'),
      membername:'',
      saveBtn:false,
      saveError:'',
      currentdate:new Date().toLocaleDateString('fr-CA'),
      date_to:new Date().toLocaleDateString('fr-CA'),
      date_from:new Date().toLocaleDateString('fr-CA'),
      name_hover: false,
      current_index: null,
    };
  },
  computed: {
    ...registrationfeeComputed,
    ...memberComputed,
    ...paymentoptionComputed,
    List() { return this.registrationfees.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.registrationfees.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.registrationfees.length>0) { a=false;} else { a=true;} return a },
    totalfees(){ var total = 0; this.registrationfees.forEach((item)=>{ var item_total = item.amount; total = Number(total)+Number(item_total);}); return total },
  },
  mounted() {
    this.fetchRegistrationFees();
    this.fetchMembers();
    this.fetchPaymentoptions();
    this.TotalRows = this.registrationfees.length;
    this.isBusy=false;
    this.amount = this.userData.settings.membership_fee;
  }, 
  methods: {
    ...registrationfeeMethods,
    ...memberMethods,
    ...paymentoptionMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async addRegistrationFees() {
      this.saveBtn=true;
      this.saveError="Saving Registration Fees";
      let formData = new FormData();
      formData.append("member", this.member);
      formData.append("amount", this.amount);
      formData.append("mode_of_payment", this.mode_of_payment);
      formData.append("reference", this.reference);
      formData.append("date_of_payment", this.date_of_payment);
      let url = "/addregistrationfee";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchRegistrationFees();
          this.$bvModal.hide('new-registration');
          this.member="";
          this.amount="";
          this.reference="";
          this.$toast.info("New Registration Fees Added");
          this.saveBtn=false;
          this.saveError="";
      }
      });
    },
    edit(id,member,amount,mode_of_payment,reference,date_of_payment){
      this.id=id;
      this.member=member;
      this.amount=amount;
      this.mode_of_payment=mode_of_payment;
      this.reference=reference;
      this.date_of_payment=date_of_payment;
      this.$bvModal.show('edit-registration')
    },
    approve(id,member,amount,mode_of_payment,reference,date_of_payment){
      this.id=id;
      this.member=member.member_id;
      this.membername=member.name;
      this.amount=amount;
      this.mode_of_payment=mode_of_payment.name;
      this.reference=reference;
      this.date_of_payment=date_of_payment;
      this.$bvModal.show('approve-registration')
    },
    remove(id,member){
      this.id=id;
      this.membername=member;
      this.$bvModal.show('delete-registration')
    },
   
    async editRegistrationFees(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("member", this.member);
    formData.append("amount", this.amount);
    formData.append("mode_of_payment", this.mode_of_payment);
    formData.append("reference", this.reference);
    formData.append("date_of_payment", this.date_of_payment);
    let url = "/updateregistrationfee";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchRegistrationFees();
        this.$bvModal.hide('edit-registration');
        this.member="";
        this.amount="";
        this.reference="";
      }
    });
    },
    async approveRegistrationFees(){
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/approveregistrationfee";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchRegistrationFees();
        this.$bvModal.hide('approve-registration');
      }
    });
    },
    async removeRegistrationFees() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removeregistrationfee";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchRegistrationFees();
        this.$bvModal.hide('delete-registration');
      }
    });
    },
    FilterData() {
        this.filterRegistrationFees({datefrom:this.date_from,dateto:this.date_to});
      },
  },
};
</script>